import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import { UPDATE_EMAIL_SUBSCRIBED_ALL, UPDATE_EMAIL_SUBSCRIBED_SEGMENT } from "../../../store/marketing/marketing-actions";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SegmentSubscribedButton",
  components: {
    InlinePrompt,
    SimpleButton
  },
  props: {
    subscribed: {
      type: Boolean,
      required: true
    },
    suppressed: {
      type: Boolean,
      required: true
    },
    source: {
      type: String,
      required: true
    },
    listId: {
      type: String,
      required: true
    },
    emailId: {
      type: String,
      required: true
    },
    currentTab: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      clicked: false,
      localSubscribed: !this.suppressed
    };
  },
  computed: {
    isSubscribed() {
      return this.subscribed && !this.suppressed;
    },
    isSubscribedDisabled() {
      return !this.subscribed;
    },
    subscribedText() {
      return this.isSubscribed && !this.clicked ? this.$t("global.words.subscribed") : this.$t("global.words.unsubscribed");
    },
    subscribeConfirmText() {
      return this.isSubscribed ? this.$t("lists.messages.confirmUnsubscribe") : this.$t("lists.messages.confirmResubscribe");
    },
    disabledTooltipText() {
      return this.isSubscribedDisabled ? this.$t("lists.messages.userCannotResubscribe") : "";
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("MarketingStore", [UPDATE_EMAIL_SUBSCRIBED_ALL, UPDATE_EMAIL_SUBSCRIBED_SEGMENT])), {}, {
    handleButtonFinish() {
      this.localSubscribed = !this.suppressed;
    },
    async handleSubscribe() {
      // for jQuery to get updated text value before button animation
      this.clicked = true;
      await this.$nextTick();
      this.loading = true;
      const data = {
        suppressed: {
          suppressed: !this.suppressed
        },
        listId: this.listId,
        emailId: this.emailId
      };
      if (this.currentTab === "all") {
        await this.UPDATE_EMAIL_SUBSCRIBED_ALL(data);
      } else {
        data.segmentId = this.currentTab;
        await this.UPDATE_EMAIL_SUBSCRIBED_SEGMENT(data);
      }
      this.$emit("subscribe");
      await this.$nextTick();
      this.loading = false;
      await this.$nextTick();
      this.clicked = false;
    },
    handleClick(event) {
      if (this.isSubscribedDisabled) {
        event.stopPropagation();
      }
    }
  })
});